"use client";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
// import SearchFormResultsDialog from './SearchFormResultsDialog';
import { getData, postData } from "@/utils/frontend/dataOps";
import { IndigoButton, TealButton } from "../Buttons/ColorButtons";
import Link from "next/link";
import Loading from "../Alerts/Loading";
import { useRouter } from "next/navigation.js";
import { getCookies } from "@/utils/frontend/cookieOps";

const SearchFormGlobal = ({ callback, lang, query, targetModule }) => {
  const user = getCookies().user;
  const wrapperRef = useRef(null);
  const router = useRouter();

  const [searchTerm, setSearchTerm] = useState(query || "");
  const [loading, setLoading] = useState(false);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsListOpen, setSuggestionListOpen] = useState(false);
  const [searchInputOpen, setSearchInputOpen] = useState(false); // unused

  const [searchFormResultsDialogOpen, setSearchFormResultsDialogOpen] =
    useState(false);
  const [searchFormResults, setSearchFormResults] = useState(null);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleChildCallback = (callback) => {
    if (callback.action === "searchForm") {
      setSearchFormResultsDialogOpen(callback.searchFormResultsDialogOpen);
      setSearchFormResults(callback.searchFormQueryResponse);
    }
  };

  let queryUrl;
  if (targetModule === "JOBS") {
    queryUrl = `jobs?filter=true&query=${searchTerm}`;
  } else if (targetModule === "TALENT") {
    queryUrl = `talent?filter=true&query=${searchTerm}`;
  }

  useEffect(() => {
    const searchBox = document.querySelector("#searchBox");

    const handleEnter = (e) => {
      if (e.key === "Enter") {
        setLoading(true);
        router.push(`/${queryUrl}`);
      }
    };

    searchBox.addEventListener("keypress", handleEnter);

    if (searchTerm.trim() === "") {
      setSuggestions([]);
      return;
    }

    let timeoutId;

    const fetchSuggestions = async () => {
      try {
        setSuggestionsLoading(true);
        const searchResults = await getData(
          `${queryUrl}&lang=${lang}&user_type=${user?.user_type || "PUBLIC"}`
        );
        console.log("searchRes", searchResults);
        setSuggestions(searchResults.searchFieldSuggestions);
        setSuggestionListOpen(true);
      } finally {
        setSuggestionsLoading(false);
      }
    };

    // outside click
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSuggestionListOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    timeoutId = setTimeout(fetchSuggestions, 300);

    // 🔥 SINGLE CLEANUP FUNCTION
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      searchBox.removeEventListener("keypress", handleEnter);
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  //   useEffect(() => {
  //     document.querySelector('#searchBox').addEventListener('keypress', function (e) {
  //       if (e.key === 'Enter') {
  //           setLoading(true)
  //         window.location=`/${lang}/jobs?filter=true&query=${searchTerm}`
  //       }
  //   });

  //     if (searchTerm.trim() === '') {
  //       setSuggestions([]);
  //       return;
  //     }

  //     let searchResults;

  //     const fetchSuggestions = async () => {

  //      try {
  //           // searchResults = await postData(`services/search?query=${searchTerm}`);
  //           setSuggestionsLoading(true)
  //           searchResults = await getData(`jobs?filter=true&query=${searchTerm}&lang=${lang}`);
  //           console.log(searchResults)
  //           setSuggestions(searchResults.searchFieldSuggestions);
  //           setSuggestionListOpen(true)
  //           setSearchFormResultsDialogOpen(true);
  //      }
  //      catch (error){
  //           console.log(error)
  //      }
  //      finally {
  //           setSuggestionsLoading(false)
  //      }
  //     };

  //      // close suggestions list when clicked outside.
  //      function handleClickOutside(event) {
  //      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
  //           setSuggestionListOpen(false);
  //      }
  //      }

  //      document.addEventListener("mousedown", handleClickOutside);
  //      return () => document.removeEventListener("mousedown", handleClickOutside);

  //     // Delay the API request to avoid sending too many requests while typing
  //     const timeoutId = setTimeout(() => {
  //       fetchSuggestions();
  //     }, 300);

  //     // Cleanup function to clear the timeout on component unmount or rapid typing
  //     return () => clearTimeout(timeoutId);
  //   }, [searchTerm]);

  return (
    <>
      {/* <a href = "#" onClick={()=>{setSearchInputOpen(true)}}>
          <span className={`${searchInputOpen ? 'hidden' : 'inline'} z-50 text-lg block xl:text-2xl transition delay-10 duration-300 ease-in-out bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded-lg dark:text-gray-200 py-1 px-2`}>x
          <i className="fa-solid fa-magnifying-glass"></i>
          </span>
        </a> */}
      {/* {loading && <Loading lang={lang}/>} */}
      <div
        ref={wrapperRef}
        className={` relative ${
          searchInputOpen ? "md:w-full" : "md:w-full"
        } duration-300 gap-4 flex flex-col`}
      >
        {/* SUGGESTION  WITH PILL / TAG BELOW */}
        {/* <div className="relative flex flex-wrap items-center gap-2 px-2 py-2 rounded-md dark:bg-gray-700">
  {
//   ['a', 'b', 'c'].map(tag => (
    searchTerm && <span
      key={'tag'}
      className="bg-blue-100 text-blue-700 px-2 py-1 rounded-md text-xs"
    >
      {searchTerm}
    </span>
//   ))
  }

  <input
    id="searchBox"
    type="text"
    className="flex-1 bg-transparent text-sm outline-none dark:text-white min-w-[80px]"
    placeholder="Job Title, Industry, Keywords"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div> */}

        <div className="grid md:grid-cols-3 gap-2">
          <div className="md:col-span-2">
            <input
              id="searchBox"
              type="text"
              className="min-h-14 max-h-14 border border-slate-300 dark:border-slate-600 dark:bg-slate-700 bg-white bg-opacity-25 dark:bg-opacity-50 dark:text-white relative w-full px-4 py-4 rounded-lg text-sm outline-none "
              placeholder={
                lang === "fr"
                  ? "Titre de poste, industrie, mots-cles"
                  : "Job Title, Industry, Keywords"
              }
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={() => setSuggestionListOpen(true)}
            />
          </div>
          <div className="md:col-span-1">
            <Link href={`/${queryUrl}`}>
              <div className="w-full">
                <TealButton
                  buttonSize={1}
                  border={true}
                  loading={loading}
                  caption={
                    lang === "fr" ? (
                      <>
                        Rechercher{" "}
                        {/* <i className="ml-1 fa-solid fa-magnifying-glass"></i> */}
                      </>
                    ) : (
                      <>
                        Search{" "}
                        {/* <i className="ml-1 fa-solid fa-magnifying-glass"></i> */}
                      </>
                    )
                  }
                />
              </div>
            </Link>
          </div>
        </div>

        {/* UNCOMMENT FOR SUGGESTIONS */}
        {suggestionsLoading && (
          <p className="absolute top-20 right-4 text-sm">
            {lang === "fr" ? "Chargement..." : "Loading..."}
          </p>
        )}

        {suggestions && suggestionsListOpen && (
          <ul className="absolute z-30 bg-white dark:bg-slate-900 dark:text-white rounded-md mt-16 w-full">
            {suggestions.tags?.length > 0 && (
              <>
                <div className="text-gray-300 font-light rounded-t-md px-2 pt-2">
                  <p className="text-sm">Tags</p>
                </div>
                {suggestions.tags.map((suggestion) => (
                  <li
                    onClick={(x) => {
                      setSearchTerm(x.target.innerText);
                      setTimeout(() => {
                        setSuggestionListOpen(false);
                      }, 400);
                      setLoading(true);
                      // router.push(`../../../${lang}/jobs?filter=true&query=${x.target.innerText}`)
                      setLoading(false);
                    }}
                    key={suggestion.id}
                    className="py-2 px-4 hover:bg-slate-50 dark:hover:bg-slate-800 cursor-pointer rounded-md"
                    // Add an onClick handler to handle selection
                    // onClick={() => console.log('Selected:', suggestion)}
                  >
                    {suggestion[`tag_name_${lang}`]}
                  </li>
                ))}
              </>
            )}
            {suggestions.industries?.length > 0 && (
              <>
                <div className="text-gray-300 font-light rounded-t-md px-2 pt-2">
                  <p className="text-sm">Industries</p>
                </div>
                {suggestions.industries.map((suggestion) => (
                  <li
                    onClick={(x) => {
                      setSearchTerm(x.target.innerText);
                      setSuggestionListOpen(false);
                      setLoading(true);
                      setTimeout(() => {
                        setSuggestionListOpen(false);
                      }, 400);
                      // router.push(`../../../${lang}/jobs?filter=true&query=${x.target.innerText}`)
                      setLoading(false);
                    }}
                    key={suggestion.id}
                    className="py-2 px-4 hover:bg-slate-50 dark:hover:bg-slate-800 cursor-pointer text-base rounded-md"
                    // Add an onClick handler to handle selection
                    // onClick={() => console.log('Selected:', suggestion)}
                  >
                    {suggestion[`label_${lang}`]}
                  </li>
                ))}
              </>
            )}
          </ul>
        )}

        {/* {suggestions?.tags?.length > 0 && (
        <ul className="absolute z-50 bg-white border rounded-md mt-10 w-full">
          <div className='text-gray-300 font-light rounded-t-md px-2'><p className='text-sm'>Tags</p></div>
          {suggestions.tags.map((suggestion) => (
            <li
              key={suggestion.id}
              className="py-2 px-4 hover:bg-slate-50 cursor-pointer"
              // Add an onClick handler to handle selection
              // onClick={() => console.log('Selected:', suggestion)}
            >
              {suggestion[`tag_name_${lang}`]}
            </li>
          ))}
        </ul>
      )} */}

        {/* {suggestions?.industries?.length > 0 && (
        <ul className="absolute z-50 bg-white border rounded-md mt-10 w-full">
          <div className='text-gray-300 font-light rounded-t-md px-2'><p className='text-sm'>Tags</p></div>
          {suggestions.industries.map((suggestion) => (
            <li
              key={suggestion.id}
              className="py-2 px-4 hover:bg-slate-50 cursor-pointer"
              // Add an onClick handler to handle selection
              // onClick={() => console.log('Selected:', suggestion)}
            >
              {suggestion[`label_${lang}`]}
            </li>
          ))}
        </ul>
      )} */}
      </div>
      {/* <SearchFormResultsDialog data={searchFormResults} callback={handleChildCallback} state={{searchFormResultsDialogOpen: searchFormResultsDialogOpen, setSearchFormResultsDialogOpen: setSearchFormResultsDialogOpen, success: success, setSuccess: setSuccess, error: error, setError: setError}}/> */}
    </>
  );
};

export default SearchFormGlobal;
